import React from 'react';
import './AboutUs.css';


const AboutUs = ({ language, setActiveSection }) => {
  const content = {
    pt: {
      title: "Quem Somos",
      whoWeAre: [
        "Na <strong>Focus Saúde e Exercício</strong> acreditamos no poder da dedicação e do acompanhamento personalizado.",
        "A nossa equipa multidisciplinar está pronta para apoiar cada cliente e atleta, promovendo o seu bem-estar físico e mental num ambiente acolhedor.",
        "Oferecemos-lhe serviços de <strong>fisioterapia, Geriatria, Saúde Pélvica, Treino personalizado, Pilates Clínico, nutrição, e massagens</strong>, tudo num só espaço. Aqui, <strong>o seu progresso é a nossa prioridade<strong>. Trabalhamos diariamente para o ajudar a alcançar os seus objetivos com confiança e em segurança."
      ],
      missionTitle: "A Nossa Missão",
      mission: [
        "Proporcionamos um ambiente confortável, agradável e acolhedor.",
        "Queremos que todos se sintam bem-vindos e confiantes.",
        "Oferecemos serviços especializados  especializados em <strong>Fisioterapia</strong>, <strong>Treino Personalizado</strong>, <strong>Nutrição e Bem-estar</strong>.",
        "Tudo num só espaço, com os profissionais certos para o seu bem-estar integral."
      ]
    },
    en: {
      title: "Who We Are",
      whoWeAre: [
        "Our name is <strong>Focus</strong> – Health and Exercise.",
        "We are professionals from complementary healthcare fields.",
        "Our goal is to provide clients and athletes with the best personalized care in one location.",
        "We support <strong>Musculoskeletal Health</strong>, <strong>Geriatrics</strong>, <strong>Pelvic Health</strong>, <strong>Personal Training</strong>, <strong>Clinical Pilates</strong>, <strong>Postural Reeducation (RPG)</strong>, <strong>Nutrition</strong>, and <strong>Massage Therapy</strong>."
      ],
      missionTitle: "Our Mission",
      mission: [
        "We provide a comfortable, pleasant, and welcoming environment.",
        "We want everyone to feel welcome and confident.",
        "We offer specialized and personalized services in <strong>physiotherapy</strong>, <strong>personal training</strong>, <strong>nutrition and well-being</strong>.",
        "All in one place, with the right professionals to support your complete well-being."
      ]
    }
  }[language];

  const buttonText = {
    en: "Explore Our Services",
    pt: "Explorar os Serviços"
  }[language];

  return (
    <>
      <div className="about-wrapper">
        <section className="about-section who-we-are">
          <h2 className="fade-in-up" style={{ '--delay': '0s' }}>{content.title}</h2>
          {content.whoWeAre.map((line, idx) => (
            <p
              key={`who-${idx}`}
              className="fade-in-up"
              style={{ '--delay': `${(idx + 1) * 0.2}s` }}
              dangerouslySetInnerHTML={{ __html: line }}
            />
          ))}
        </section>

        <section className="about-section mission">
          <h3 className="fade-in-up" style={{ '--delay': '0s' }}>{content.missionTitle}</h3>
          {content.mission.map((line, idx) => (
            <p
              key={`mission-${idx}`}
              className="fade-in-up"
              style={{ '--delay': `${(idx + 1) * 0.2}s` }}
              dangerouslySetInnerHTML={{ __html: line }}
            />
          ))}
        </section>

        <div className="services-button-wrapper">
          <button className="services-button" onClick={() => setActiveSection('services')}>
            {buttonText}
          </button>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
